import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PaginatedWarehouseVehicleSetup } from 'contracts/WarehouseVehicleSetups';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_WAREHOUSE_VEHICLE_SETUPS_',
  }
);

export interface PaginateWarehouseVehicleSetupsState {
  data: PaginatedWarehouseVehicleSetup[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateWarehouseVehicleSetupsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedWarehouseVehicleSetup[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateWarehouseVehicleSetupsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateWarehouseVehicleSetupsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: PaginateWarehouseVehicleSetupsState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (
  state: PaginateWarehouseVehicleSetupsState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateWarehouseVehicleSetupsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateWarehouseVehicleSetups = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateWarehouseVehicleSetupsTypes = Types;
export const PaginateWarehouseVehicleSetupsActions = Creators;
